import { render, staticRenderFns } from "./viewIntegrationData.vue?vue&type=template&id=c39988ce&scoped=true"
import script from "./viewIntegrationData.vue?vue&type=script&lang=js"
export * from "./viewIntegrationData.vue?vue&type=script&lang=js"
import style0 from "./viewIntegrationData.vue?vue&type=style&index=0&id=c39988ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39988ce",
  null
  
)

export default component.exports